module.exports = __webpack_public_path__ + "static/kirche-bf487a143c01af0e6408241d8f88661f.PNG";